<template lang="pug">
  div
    // Navbar
    navbar-transparent(
      :opacity="navbarOneOpacity",
      )
    navbar(
      :opacity="navbarTwoOpacity",
      :float="true",
      @focusInput="toggleSearchBarInput",
      @unfocusInput="toggleSearchBarInput",
      )
    // 搜尋欄(現行暫時停止)
    // search-bar(:searchBarActive="searchBarActive",@closeSearchBar="toggleSearchBar()")
    // 建議登入的跳窗
    login-modal(
      :loginModalActive = "suggestLoginModal",
      @foward="fowardToLogin()",
      @cancel="closeLoginModal()",
      @closeModal="closeLoginModal()"
    )
    //- // 白色蓋版
    //- transition(name="fade")
    //-   .white-modal(
    //-     v-if="whiteModalActive",
    //-     @click="toggleWhiteModal(false)"
    //-     )
    // 蓋板廣告
    transition(name="fade")
      overlay-ads(
        :adContent="overlayAds",
        :available="overlayAdsAvailable",
        :countdown="overlayAdsCountdown"
        @closeAds="closeOverlayAds"
      )
    // 內容存放區
    .container
      // 廣告輪播(大小為APP版的大小)
      ads-carousel(
        :events="eventBanners",
        :loading="initialLoading")
      // 主題策展icons
      #curations-1.section
        .block(v-for="(event,eid) in curationList",:key="'curation-'+eid",ref="curationBlock")
          img(src="@/assets/img/preload_curations.svg" v-if="event.pic == ''")
          img(:src="event.pic" v-else)
          .title {{event.title}}
          a.no-blue-highlight(
            :href="event.link",
            )
      // 24h熱銷區塊
      #hotsale.section
        .section-header
          .title TOP熱銷
          .icon
            img(
              src="@/assets/icons/ic_link_to_xs.png"
            )
          a.touch-area.no-blue-highlight(href="/m/p24h")
        .section-content
          swiper(:options="hotsaleSwiper")
            swiper-slide(v-for="(event,eid) in topSale",:key="'hotsale-'+eid")
              product-block(
                :product="event",
                :type="3",
                :loading="initialLoading",
                :isAuthenticated="memberInfo.isAuthenticated"
                )
      // 季度策展或活動策展
      events-carousel(
        v-for="(event,eid) in curationEvents",
        :products="event.deals",
        :banner="event.banner",
        :key="'curation-event:'+eid"
        )
      // 一般商品檔次區
      .normal-event.section(v-for="(cata,cid) in normalEvents")
        .normal-event-content
          .normal-event-banner
            img(
              v-if="!initialLoading",
              :src="cata.banner.pic")
            // Masking Loading Gif
            img(
              src="@/assets/img/preload_placeholder_lg.gif",
              v-else
            )
            // Link
            a.no-blue-highlight(:href="cata.banner.link")
          product-block(
            v-for="(event,eid) in cata.deals.slice(0,5)",
            :key="'event-'+cid+eid",
            :product="event",
            :type="1",
            :loading="initialLoading",
            :isAuthenticated="memberInfo.isAuthenticated",
            @clickFavorite="requestCollectStatus",
            )
        .normal-event-more
          a.btn-more.no-blue-highlight(:href="cata.banner.link")
            p 去看更多
            .icon
              img(
                src="@/assets/icons/ic_link_to_xs.png"
              )
      // 猜你喜歡區塊
      .crm-products.section
        .section-header
          .title 猜你也會喜歡
        .crm-products-content
          product-block(
            v-for="(product,pid) in crmProducts",
            :key="'crm-product-'+pid",
            :product="product",
            :initial="false",
            :discount="true",
            :type="1",
            :badge="true",
            :loading="initialLoading",
            :isAuthenticated="memberInfo.isAuthenticated",
            @clickFavorite="requestCollectStatus"
            )
        .crm-products-more(
          @click="crmProductsMore()"
        )
          transition(name="fade" mode="out-in")
            .btn-more(v-if="crmLoaded")
              p 去看更多
              .icon
                img(
                  src="@/assets/icons/ic_link_to_arrow_down_sm.png"
                )
            .loading-circle(v-else="!crmLoaded")
              svg(viewBox="25 25 50 50")
                circle(cx="50",cy="50",r="20")
      // Footer
      vue-footer(:baseURL="baseURL")
</template>

<script>
import NavbarTransparent from '../../components/NavbarTransparent.vue';
import Navbar from '../../components/Navbar.vue';
import AdsCarousel from '../../components/AdsCarousel.vue';
import EventsCarousel from '../../components/EventsCarousel.vue';
import ProductBlock from '../../components/ProductBlock.vue';
import LoginModal from '../../components/LoginModal.vue';
import VueFooter from '../../components/Footer.vue';
import OverlayAds from '../../components/OverlayAds.vue';
// import SearchBar from '../../components/SearchBar.vue';
import {mapState,mapActions} from 'vuex';


export default {
  name: 'app',
  components: {
    NavbarTransparent,
    Navbar,
    AdsCarousel,
    EventsCarousel,
    ProductBlock,
    // SearchBar,
    LoginModal,
    VueFooter,
    OverlayAds,
  },
  data(){
    return{
      crmAppendIndex: 0,
      hotsaleSwiper:{
        slidesPerView: 'auto',
        initialSlide: 0,
        spaceBetween: 8,
        slidesOffsetAfter: 12,
        resistanceRatio: 0.90,
        loop: false,
        slidesOffsetBefore: 16
      },
      menuActive: false,
      searchBarActive: false,
      suggestLoginModal: false,
      baseURL:'.',
      pageScrollFixed: false,
      categoryNumber: null,
      windowWidth: document.body.clientWidth,
      eventActiveIndex: 0,
      navbarOneOpacity: 1,
      navbarTwoOpacity: 0,
      whiteModalActive: false
    }
  },
  computed: {
    ...mapState({
      eventBanners: 'eventBanners',
      curationList: 'curationList',
      topSale: 'topSale',
      curationEvents: 'curationEvents',
      normalEvents: 'normalEvents',
      crmProducts: 'crmProducts',
      initialLoading: 'initialLoading',
      memberInfo: 'memberInfo',
      crmLoaded: 'crmLoaded',
      overlayAds: 'overlayAds',
      overlayAdsAvailable: 'overlayAdsAvailable',
      overlayAdsCountdown: 'overlayAdsCountdown',
    }),
  },
  methods:{
    // 映射store.js的物件
    ...mapActions({
      recommandItemsRequest: 'recommandItemsRequest',
      contentRequest: 'contentRequest',
      getMemberInfo: 'getMemberInfo',
      setMemberCollect: 'setMemberCollect',
      getOverlayAds: 'getOverlayAds',
    }),
    // 開關搜尋欄(下階段施作)
    toggleSearchBar(){
      // 開啟與關閉搜尋欄位區塊
      // this.searchBarActive = !this.searchBarActive

      // 直接跳轉
      location.href= this.baseURL+"/m/Search";
    },
    // 開關白色蓋版
    toggleSearchBarInput(boolean){
      if(boolean){
        // 導覽條的透明度變化
        this.navbarTwoOpacity = 1;
      }else{
        // 導覽條的透明度變化
        this.navbarTwoOpacity = this.navbarTwoOpacityCalc();
      }
    },
    // 連到收藏頁面
    linkToFavorite(){
      // console.log('點擊我的收藏');
      location.href= this.baseURL+"/User/Collect.aspx";
    },
    linkToMember(){
      location.href= this.baseURL+"/m/Member";
    },
    // 看更多猜你喜歡
    crmProductsMore(){
      // 計數加一
      this.crmAppendIndex ++;
      let startIndexNew = this.crmAppendIndex*10;
      // request更新
      let params = {
        startIndex: startIndexNew,
        pageSize: 10
      }
      this.recommandItemsRequest(params);
    },
    // 送出收藏要求
    requestCollectStatus(status){
      if(status != false){
        this.setMemberCollect(status)
        // console.log(status)
      }else{
        this.suggestLoginModal = true
      }
    },
    // 切換捲動鎖定
    toggleScrollFixed(){
      if(this.pageScrollFixed){
        document.body.classList.add('scroll-fixed');
      }else{
        document.body.classList.remove('scroll-fixed');
      }
    },
    // 關閉登入提醒跳窗
    closeLoginModal(){
      this.suggestLoginModal = false;
    },
    // 前往登入頁面
    fowardToLogin(){
      this.suggestLoginModal = false;
      window.location.href= this.baseURL+"/m/login"
    },
    // 關閉蓋板廣告
    closeOverlayAds(){
      this.$store.state.overlayAdsAvailable = false
    },
    // 計算導航透明度
    navbarOneOpacityCalc(){
      var scrollY = window.scrollY
      var scrollRatio = (140-scrollY)/100
      return scrollRatio
    },
    navbarTwoOpacityCalc(){
      var scrollY = window.scrollY
      var scrollRatio = 0+((scrollY-40)/100)
      return scrollRatio
    },
    // 上方導航欄透明度變化
    modifyNavbarOpacity(){
      if(scrollY>40){
        this.navbarOneOpacity = this.navbarOneOpacityCalc();
        this.navbarTwoOpacity = this.navbarTwoOpacityCalc();
      }else{
        this.navbarOneOpacity = 1
        this.navbarTwoOpacity = 0
      }
    },
    // 捲動監聽事件
    eventListenScroll(){
      window.addEventListener('scroll',this.modifyNavbarOpacity);
    },
    eventListenScrollDisable(){
      window.removeEventListener('scroll',this.modifyNavbarOpacity);
    }
  },
  created(){
    // 讀取會員登入資訊
    this.getMemberInfo();
  },
  beforeMount(){
    // 初始更新分類區域的tab
    let config = {
      cityId: document.cookie.CityId,
      preview: true
    }
    // 初始讀取網站資料 - 主頁顯示與側邊欄欄目
    this.contentRequest(config);
    // 決定是否顯示蓋板廣告
    // this.decideOverlayAdsAvailable();
    // 取得蓋板廣告資訊
    this.getOverlayAds();
  },
  // 定義畫面寬度
  setWindowWidth(){
    this.windowWidth = document.body.clientWidth
  },
  watch:{
    pageScrollFixed(){
      this.toggleScrollFixed();
    },
    // 按下搜尋欄時讓背景不能動
    searchBarActive(){
      if(this.searchBarActive){
        this.pageScrollFixed = true;
      }else{
        this.pageScrollFixed = false;
      }
    },
    // 開啟建議登入跳窗時不能捲動
    suggestLoginModal(){
      if(this.suggestLoginModal){
        this.pageScrollFixed = true
      }else{
        this.pageScrollFixed = false
      }
    },
  },
  mounted(){
    this.eventListenScroll();
  },
  destroyed(){
    this.eventListenScrollDisable();
  }
}
</script>

<style lang="scss">
  @import '@/assets/style/layout.scss';
  @import '@/assets/style/index.scss';
</style>
